export const loadState = () => {
    try {
        const serializedState = localStorage.getItem("rxState");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const loadBookingInfoState = () => {
    try {
        const serializedState = localStorage.getItem("bkState");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};